import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { EmployeesService } from 'src/pehra-ts-client';
import styles from './TransferToOtherDistrictModal.module.css';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from 'src/hooks/useNotification';
export interface ITransferToOtherDistrictModal {
  openDeleteModal: boolean;
  handleCloseDeleteModal: () => void;
  handleDelete: (description: string) => void;
  data?: any; // Pass description to parent handler
}

const TransferToOtherDistrictModal: React.FC<ITransferToOtherDistrictModal> = ({ openDeleteModal, handleCloseDeleteModal, handleDelete ,data}) => {
  const [description, setDescription] = useState<string>(''); // State to store user input
  // const [error, setError] = useState<boolean>(false); // State to track validation error
  const { id, name, current_office_id, punishments, ...rest } = data;
  const queryClient = useQueryClient();
  const [sendNotification] = useNotification();


  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(event.target.value);
  };



const handleTransferToOffice = async () => {
      try {
        const res = await EmployeesService.transferToOtherDistrict({
            employee_ids:[id],
            other_details:description
        })
        return res;
      } catch (error) {
        throw error;
      }

    }


  const addEmployeeToOtherDistrictMutation = useMutation({
    mutationFn: handleTransferToOffice,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['employeeTransfferedToOtherDistrict']
      });

      sendNotification({
        msg: 'Employee added to transfer to other district list',
        type: 'success'
      });

      handleCloseDeleteModal()

      setDescription(''); // Clear the text field after submission

    }
  });

    const handleSubmit = () => {
      addEmployeeToOtherDistrictMutation.mutate()
  };

  return (
    <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
      <Box
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          padding: '30px',
          outline: 'none',
          width: '500px'
        }}
      >
        <Typography variant="h3" gutterBottom>
          Transfer to Other District
        </Typography>



        {/* TextField for user input */}
        <TextField
          fullWidth
          label="Write a Description Here.."
          variant="outlined"
          value={description}
          onChange={handleInputChange}
          margin="normal"
          // error={error} // Show error state
          // helperText={error ? 'Description is required' : ''} // Error message
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}
        >
          <Button variant="outlined" color="error" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="info"
            onClick={handleSubmit}
            style={{ marginLeft: '10px' }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TransferToOtherDistrictModal;
